import CryptoJS from 'crypto-js'
import { isJson } from './utils'
const NodeRSA = require('node-rsa')
// 白名单接口不走加密
export const whiteApi = []
/**
 * 辅助函数：生成随机16字节密钥
 * @returns {string} 16字节随机密钥
 */
const generateRandomKey = () => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  let key = ''
  for (let i = 0; i < 16; i++) {
    key += chars.charAt(Math.floor(Math.random() * chars.length))
  }
  return key
}
export const AESKEY = generateRandomKey() //'1234567890123456'

// RSA私钥
const rsaPrivate =
  'MIIEvQIBADANBgkqhkiG9w0BAQEFAASCBKcwggSjAgEAAoIBAQCDWc+otCHyBlaJFGFdeL19ovKVHWHQGWpq5CN/ysUHQ5TMrBiGb2VvT9vjzVaiAIfVcAWbf+/FRg4YA5EWDM1nYRjXMyauZdg/Cpwqz2l+L1nbyc7oNS2Fh8ia92tRSXGKtekKttCn/IbzRiio77woPbJjmUttN5wrIHMhNpbPS+q7xapkn/WMXZtyrKQ5QvL/lt1pu7IQZb2ttsj2iVJgiBTj/QuHu8NlfY3em8VlnUyKffoHNWY6YN+1ygMQvkYYEG9se7pR81kkptoppdu1Mm9LInJo3ebIcb5SZEkn1HQ+L7a1VX/6fJlGJ9HtrKqunmmCpiAHxxFNHyFvjVSDAgMBAAECggEAVbFOLP3393HzGtNVAio3VbPtFyNoIN+z8bCNCF49VJPei/jqtyoNvyUWi/P2xRIbjD/dKKm6v7UIlNoe2YfYqc1K63rPjY+cGOTPJY7TgCNcOGvctNmcrTT8xz0LoqiLjrdHJlpGnpG9aREoja55zrcRnrDv6H0TQX+WHOEEWpB5VhmMe/X0czmvsEaf14axCZicefsovTDUihxaqER4LQs0BVAbnCMwLbRVE1CCgY+m2ozFCg+WjHVaZmVkPSLN856LFhXLqBXnQ/Ul1GKUCb9wzd1ndikhrpFvH0nM+T4RRBrWj5b3YvOP3ZnrMZ6j74BYq2nExJLScc8KvvrSoQKBgQC93uZMtUHvBJafGKR51K7+o/zgUlH+vfZV8Sj5MCDkp64j4yhT8pHKhTAprtSs1YPmzlvDulFtV3j+vCFC6DcdboNtLwzTz1u8phdAXAk0PzH5YtsvQ4Dh1JXG7vQYC4uTLfJjS4tjyFRjShJKhJ+yrr6NAbhEPt+hUK77h78xTwKBgQCxGTV5Ys8XHt03vE7pquEqXO7OflPdqct7Z9ymYs5CvznISRAbc7y2BtvH0fTmr9gDBjybeLcJ4/XM7kKi+OW+BeYDoBPPBytWgHNUSqCy+pdglYrXQSRCVn1zOpMDa34ayyTC4qGd9/06XE3ObKf2gHWkiMUkh8lvJOFnUwsUjQKBgAkGTjX5K5AbzLj1J+Quir7JtpxG7WTJTKsbElJ9yiJ0Id/MzT7oOavBlt90UuGAKIvQ5SWxdmtXDAY3lPEkLnJ0rUSERvzOT1LxJgvGFB3qnwp2e2qMr9SMES5qbymxasntFidIEPEGNZSeka3/DcQlcCMtoL+FqYV2W0rTUfAbAoGBALCp1Q4h4zPNNiBDWPT/4V3BFvgmTMLyfmm8UgAo0FkFKT8Co26/JaDvdo7+gq8c+v8JWaw931mebbTgeNjaMVQ9zhYPubLsE+9Wc7XCPExObnOKudXAxcrnPH2WENF4iXNw8lr2eQJ8P7/YFEW3XlYoDzLyvLaUPf0BbVkFHiiBAoGATz6tMj09yKE2rBYoc8nJGaajOBwg9jpl8kwhg2Q40eIEB14fK3F2sqDm1qK4ozhTts1K8kSzRsFdVkJtFhBD+QIIUdfSb56hqbNN99cvbOrT6DJVVo03Z/BTetr9KlVwaO+/0GDhC2O6h101ZwXqTd0EK7Z4ICCR9jt+eKTsjZY='
// DES加密
export const encryp = (str, key = 'e#2sy^2u') => {
  let keyHex = CryptoJS.enc.Utf8.parse(key)
  // 2. 转换明文：UTF-8 编码
  let encrypted = CryptoJS.DES.encrypt(str, keyHex, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  })
  return encrypted.toString()
}

// DES解密
export const decrypt = (str, key = 'e#2sy^2u') => {
  const keyHex = CryptoJS.enc.Utf8.parse(key)
  const decrypted = CryptoJS.DES.decrypt(
    {
      ciphertext: CryptoJS.enc.Base64.parse(str), // base64 或 hex
    },
    keyHex,
    {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    }
  )
  return decrypted.toString(CryptoJS.enc.Utf8)
}

// AES加密
export const aesEncrypt = (str) => {
  let keyBytes = CryptoJS.enc.Utf8.parse(AESKEY)
  // 2. 转换明文：UTF-8 编码
  // 执行加密
  const encrypted = CryptoJS.AES.encrypt(str, keyBytes, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  })
  return encrypted.toString()
}

// AES解密
export const aesDecrypt = (str) => {
  const keyBytes = CryptoJS.enc.Utf8.parse(AESKEY)
  // 执行解密
  const decrypted = CryptoJS.AES.decrypt(str, keyBytes, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  })
  return decrypted.toString(CryptoJS.enc.Utf8)
}

// ==================== 密钥管理 ====================

/**
 * 生成 RSA 密钥对
 * @param {number} keySize - 密钥位数，默认 2048
 * @returns {{ publicKey: string, privateKey: string }}
 */
const generateKeyPair = (keySize = 2048) => {
  const key = new NodeRSA({ b: keySize })
  return {
    publicKey: key.exportKey('pkcs8-public-pem'),
    privateKey: key.exportKey('pkcs8-private-pem'),
  }
}

/**
 * 从 PEM 字符串创建密钥实例
 * @param {string} pemKey - PEM 格式密钥
 * @param {'public' | 'private'} type - 密钥类型
 * @returns {NodeRSA}
 */
const createKey = (pemKey, type = 'public') => {
  const format = type === 'public' ? 'pkcs8-public-pem' : 'pkcs8-private-pem'
  const key = new NodeRSA(pemKey, format)
  key.setOptions({
    encryptionScheme: {
      scheme: 'pkcs1_oaep',
      hash: 'sha1', // 可选: md5, sha1, sha256, sha512
    },
  })
  return key
}

// ==================== 基础加解密函数 ====================

/**
 * 公钥加密
 * @param {string} plainText - 明文
 * @param {string} publicKeyPem - 公钥
 * @param {string} encoding - 输出编码 'base64' | 'hex' | 'buffer'
 * @returns {string}
 */
const rsaEncrypt = (plainText, publicKeyPem, encoding = 'base64') => {
  const key = createKey(publicKeyPem, 'public')
  return key.encrypt(plainText, encoding, 'utf8')
}

/**
 * 私钥解密
 * @param {string} cipherText - 密文
 * @param {string} privateKeyPem - 私钥
 * @param {string} encoding - 输入编码 'base64' | 'hex' | 'buffer'
 * @returns {string}
 */
const rsaDecrypt = (cipherText, privateKeyPem, encoding = 'base64') => {
  const key = createKey(privateKeyPem, 'private')
  return key.decrypt(cipherText, 'utf8', encoding)
}

/**
 * 判断是否需要加密
 * @param {Object} config - 请求配置参数
 */
export const shouldEncrypt = function (config) {
  const { url, params, data, method } = config
  if (
    !whiteApi.some((s) => {
      return url.includes(s)
    })
  ) {
    console.log(data, method, '=====================')

    const publicKey = localStorage.getItem('publicKey')
    const isEncrypted = localStorage.getItem('isEncrypted')
    let tempData = data
    if (typeof data === 'object') {
      tempData = JSON.stringify(data)
    }
    if (
      isEncrypted !== 'false' &&
      isEncrypted !== false &&
      publicKey !== 'null' &&
      publicKey !== null &&
      data
    ) {
      const encrypted_data = aesEncrypt(tempData)
      const encrypted_key = rsaEncrypt(AESKEY, publicKey)
      console.log(
        '--------加密请求体--------\n',
        encrypted_data,
        '\n',
        '--------加密AES私钥--------\n',
        encrypted_key
      )
      console.log('=======解密请求体======\n', aesDecrypt(encrypted_data))

      // console.log(decrypt(text), '测试密文解析')
      console.log(
        '-----解密AES私钥-------',
        rsaDecrypt(encrypted_key, rsaPrivate)
      )
      if (method === 'post') {
        if (Object.prototype.toString.call(data) !== '[object FormData]') {
          config.data = encrypted_data
          config.headers['Content-Type'] = 'application/json'
          config.headers['X-Encrypt-Status'] = isEncrypted ? 1 : 0
        } else {
          config.headers['X-Encrypt-Status'] = 0
        }
        config.headers['Encrypted-Key'] = encrypted_key
      } else {
        config.headers['Encrypted-Key'] = encrypted_key
        config.headers['X-Encrypt-Status'] = isEncrypted ? 1 : 0
      }
    }
  }
}

/**
 * 判断是否需要解密
 * @param {Object} config - 响应参数
 */
export const shouldDecrypted = function (res) {
  const { data } = res
  if (data) {
    let c = aesDecrypt(data)
    res.data = isJson(c) ? JSON.parse(c) : c
  }
  console.log(res.data, 44444444)
}
